import { useState } from "react";
import { iconStyles } from "./style.js";
import { lString } from "../../utils.js";
const AppIcon = ({
  height,
  width,
  icon,
  type,
  name,
  nameOnChange,
  onClick,
  onRightClick = () => {},
  setNameOnChange,
  saveName,
  nameChangable = true,
  draggable = false,
  onDragStart,
  onDragEnd,
  scale = 1,
}) => {
  const [_name, changeName] = useState(name);
  const handleInput = (e) => {
    changeName(e.target.value);
  };

  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };

  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };
  return (
    <div
      style={{
        ...iconStyles.container,
        width,
        height,
        zoom: scale,
      }}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      <div
        style={iconStyles.icon}
        onClick={onClick}
        onContextMenu={onRightClick}
        onMouseOver={highlight}
        onMouseOut={unhighlight}
      >
        {icon}
      </div>
      {nameOnChange ? (
        <input
          style={iconStyles.input}
          type={"text"}
          value={_name}
          autoFocus
          onFocus={(e) => {
            e.target.select();
          }}
          onChange={handleInput}
          spellCheck={false}
          onKeyDown={(e) => {
            console.log(e.key);
            if (e.key === "Enter") saveName(_name, type);
            else if (e.key === "Escape") {
              setNameOnChange(false);
              changeName(name);
            }
          }}
        />
      ) : (
        <div
          style={{ ...iconStyles.name }}
          onClick={() => {
            if (nameChangable) setNameOnChange(true);
          }}
        >
          {lString(name, 12, "...")}
        </div>
      )}
    </div>
  );
};

export default AppIcon;
